// Trezor affiliate i18n — texts for CTAs across TopWallet.
// Affiliate ID: 159881 · Base URL: https://affiliate.trezor.io/signup/159881
// Tracker via ?sub1= query parameter, set per-article.
export const i18nTrezor = {
  ctaTitulo: {
    es: "🟩 Seguridad open source para tus criptos",
    en: "🟩 Open source security for your crypto",
    sk: "🟩 Open source bezpečnosť pre tvoje krypto", de: "🟩 Open-Source-Sicherheit für deine Kryptos", "zh-CN": "🟩 开源安全保护您的加密资产",
  },
  ctaSubtitulo: {
    es: "El primer hardware wallet del mundo. 100% open source, verificable por cualquiera. Lleva tus criptos bajo tu control.",
    en: "The world's first hardware wallet. 100% open source, verifiable by anyone. Take your crypto under your control.",
    sk: "Prvá hardvérová peňaženka na svete. 100% open source, overiteľná kýmkoľvek. Vezmi krypto pod svoju kontrolu.", de: "Das weltweit erste Hardware-Wallet. 100% Open Source, von jedem überprüfbar. Bringe deine Kryptos unter deine Kontrolle.", "zh-CN": "全球首款硬件钱包。100%开源，任何人均可验证。让您的加密资产掌握在自己手中。",
  },
  ctaBadge: {
    es: "RECOMENDADO POR RE₿EL",
    en: "RECOMMENDED BY RE₿EL",
    sk: "ODPORÚČANÉ RE₿EL", de: "EMPFOHLEN VON RE₿EL", "zh-CN": "RE₿EL 推荐",
  },
  aviso: {
    es: "Enlace de afiliado · Al comprar a través de este link apoyas a RE₿EL Academy sin coste adicional para ti.",
    en: "Affiliate link · By purchasing through this link you support RE₿EL Academy at no extra cost.",
    sk: "Partnerský odkaz · Nákupom cez tento odkaz podporuješ RE₿EL Academy bez dodatočných nákladov.", de: "Affiliate-Link · Beim Kauf über diesen Link unterstützt du RE₿EL Academy ohne zusätzliche Kosten für dich.", "zh-CN": "联盟链接 · 通过此链接购买可支持 RE₿EL Academy，您无需支付额外费用。",
  },
  mejorPrecio: { es: "Mejor precio", en: "Best price", sk: "Najlepšia cena", de: "Bester Preis", "zh-CN": "最优价格" },
  masVendida: { es: "Más vendida", en: "Best seller", sk: "Najpredávanejšia", de: "Meistverkauft", "zh-CN": "最畅销" },
  premium: { es: "Premium", en: "Premium", sk: "Premium", de: "Premium", "zh-CN": "高级版" },
  comprarEn: { es: "Comprar en Trezor →", en: "Buy at Trezor →", sk: "Kúpiť na Trezor →", de: "Bei Trezor kaufen →", "zh-CN": "在 Trezor 购买 →" },
  verTodos: { es: "Ver todos los modelos →", en: "See all models →", sk: "Zobraziť všetky modely →", de: "Alle Modelle ansehen →", "zh-CN": "查看所有型号 →" },
  openSource: {
    es: "100% Open Source verificado",
    en: "100% Verified Open Source",
    sk: "100% overený Open Source", de: "100% verifiziertes Open Source", "zh-CN": "100%开源验证",
  },
  oTambien: { es: "O TAMBIÉN", en: "OR ALSO", sk: "ALEBO TIEŽ", de: "ODER AUCH", "zh-CN": "或者" },
};

export const pickLang = (obj, lang) => (obj && (obj[lang] || obj.es)) || "";
